export default import.meta.ROLLUP_FILE_URL_B26pyb9HoJoIKaGpCM_VdQ